<template>
  <v-container
    id="classView"
    style="padding: 0;"
  >
    <v-overlay class="waitoverlay" :value="loading">
     <v-progress-circular
      indeterminate
      size="64"
      class="mr-4"
    /> {{ $t('global.loading') }}
    </v-overlay>
    <v-breadcrumbs :items="breadcrumbs" divider="-" />
    <v-card style="padding: 0">
        <v-card-title class="mb-0">
          <date-range-picker @datesChange="datesChanged" />
        </v-card-title>
        <v-card-text>
        <v-row class="mr-4 ml-4">
        <v-col cols="12" sm="4">
          <v-card><v-card-title>{{ $t('total-sessions') }}</v-card-title><v-card-text><div class="quota big" v-html="formatData(totalClassSessions)" /></v-card-text></v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card><v-card-title>{{ $t('active-users') }}</v-card-title><v-card-text><div class="quota big" v-html="formatData(activeClassUsers)" /></v-card-text></v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card><v-card-title>{{ $t('training-minutes') }}</v-card-title><v-card-text><div class="quota big" v-html="formatData(classTrainingMinutes)" /></v-card-text></v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card><v-card-title>{{ $t('new-users') }}</v-card-title><v-card-text><div class="quota big" v-html="formatData(newClassUsers)" /></v-card-text></v-card>
        </v-col>
      </v-row>
        <v-row>
          <v-col>
            <platform-usage id="platformUsage" :key="`platform-usage-${platformUsageIndex}`" :start-date="startDate" :end-date="endDate" scope="class" />
          </v-col>
      </v-row>
      <v-row>
        <v-col>
            <module-survey-explorer id="successFactors" :start-date="startDate" :end-date="endDate" :class-id="classId" scope="class" />
        </v-col>
      </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

  import moment from 'moment'
  import 'firebase/auth'
  import { downloadDashboardExportsAsPdf } from '@/helpers/shared.js'
  import DateRangePicker from './DateRangePicker'
  import PlatformUsage from './PlatformUsage'
  import ModuleSurveyExplorer from './ModuleSurveyExplorer'

  export default {
    name: 'Class',

    components: {
      'date-range-picker': DateRangePicker,
      'module-survey-explorer': ModuleSurveyExplorer,
      'platform-usage': PlatformUsage,
    },

    data () {
      return {
        classId: this.$route.params.id,
        loading: false,
        scope: 'Class',
        exportStartDate: moment().startOf('month').toDate(),
        exportEndDate: moment().endOf('month').toDate(),
        totalSessions: 0,
        activeUniqueUsers: 0,
        trainingMinutes: 0,
        newUserCount: 0,
        platformUsageIndex: 0,
        startDate: moment().startOf('month').toDate(),
        endDate: moment().endOf('month').toDate(),
        datePickerColor: 'blacktext', 
      }
    },

    computed: {
      totalClassSessions () {
        return this.$store.getters.totalClassSessions
      },
      activeClassUsers () {
        return this.$store.getters.activeClassUsers
      },
      classTrainingMinutes () {
        return this.$store.getters.classTrainingMinutes
      },
      newClassUsers () {
        return this.$store.getters.newClassUsers
      },
      className () {
        return this.$route.query.className ?? (this.currentClass ? this.currentClass.name : this.$t('global.class'))
      },
      breadcrumbs () {
        return [
          {
            text: this.$t('class.classes'),
            disabled: false,
            href: '#/admin/classes/',
          },
          {
            text: this.className,
            disabled: false,
            href: '#/admin/classes/' + this.$route.params.id,
          },
          {
            text: this.$t('class.view-stats'),
            disabled: true,
            href: '#/admin/classes/' + this.$route.params.id + '/stats',
          },
        ]
      },
    },

    async mounted () {
      this.loading = true
      this.totalSessions = this.$store.getters.totalClassSessions
      this.activeUniqueUsers = this.$store.getters.activeClassUsers
      this.trainingMinutes = this.$store.getters.classTrainingMinutes
      this.newUserCount = this.$store.getters.newClassUsers
      this.loading = false
    },

    methods: {
      formatData (data) {
        return '<span>' + data + '</span>'
      },
      refreshSummary () {
        this.platformUsageIndex += 1
      },
      datesChanged (dates) {
        this.startDate = dates[0]
        this.endDate = dates[1]
      },
      exportDataDatesChanged (date) {
        this.exportStartDate = date[0]
        this.exportEndDate = date[1]
      },
      async exportAsPdf () {
        this.loading = true
        const title = `Usage Report ${moment(this.startDate).format('DD/MM/YYYY')} - ${moment(this.endDate).format('DD/MM/YYYY')}`
        await downloadDashboardExportsAsPdf(title, this.className)
        this.loading = false
      },
    },

    
  }
</script>
<style scoped>
.big {
  font-size: 48px !important;
}
</style>
